export default function CurrencyByCode($filter, $sce, commonCurrency) {
    'ngInject';

    return function(input, currencyCode) {
        let code = commonCurrency[currencyCode]
            ? commonCurrency[currencyCode].symbol
            : currencyCode;
        if (code && code.length > 1) {
            code += ' ';
        }
        return $sce.trustAsHtml($filter('currency')(input, code));
    };
}



// WEBPACK FOOTER //
// ./src/app/filters/currencyByCode.filter.js